import type { RouteConfig } from 'vue-router';

const routes: RouteConfig[] =
  process.env.VUE_APP_RUNTIME_ENV === 'prod'
    ? []
    : [
        {
          path: '/example',
          meta: {
            excludeLogin: true,
          },
          components: {
            default: () => import('@/views/example.vue'),
            menu: () => import('@/views/menu.vue'),
          },
        },
        {
          path: '/tester/jsbridge',
          meta: {
            title: '宜享花JSBridge',
            customNavBar: true,
          },
          component: () => import('@/views//tester/jsbridge/index.vue'),
        },
        {
          path: '/tester/custom-share',
          component: () => import('@/views/tester/jsbridge/custom-share.vue'),
        },
        {
          path: '/tester/pay',
          component: () => import('@/views/tester/pay/index.vue'),
        },
        {
          path: '/tester/webapi/file',
          meta: {
            excludeLogin: true,
          },
          component: () => import('@/views/tester/webapi/file.vue'),
        },
        {
          path: '/tester/webapi/audio',
          meta: {
            excludeLogin: true,
          },
          component: () => import('@/views/tester/webapi/audio.vue'),
        },
      ];

export default routes;
